import { FilterKey } from './types';

export const AllFilterKeys: FilterKey[] = [
  'driver',
  'merchant',
  'customer',
  'delivery state',
  'payment state',
  'district',
  'governorate',
  'workflow',
  'phase',
  'pickup task state',
];

export const OrdersFilterKeys = (
  scope: 'merchant' | 'organisation'
): FilterKey[] => {
  if (scope == 'merchant')
    return [
      'customer',
      'phase',
      'delivery state',
      'payment state',
      'district',
      'governorate',
      'workflow',
    ];
  return [
    'driver',
    'merchant',
    'customer',
    'delivery state',
    'payment state',
    'district',
    'governorate',
    'workflow',
    'phase',
    'branch'
  ];
};

export const PickupTaskFilterKeys: FilterKey[] = [
  'driver',
  'merchant',
  'customer',
  'district',
  'workflow',
  'pickup task state',
];

export const DeliveryBatchFilterKeys: FilterKey[] = [
  'driver',
  'delivery batch state',
];
